import React, { useState, createContext } from "react";

const valuesTransaccional = {
  identificacion: "",
  idCliente: "",
  idGrupo: 0,
  opcionMenu: 0,

  merchantId: "",
  linkPayment: "",

  informacionTransaccional: {},

  stateVerificar: false, //cambiar de component deobtener URL a  verifiquar

  verificarPayment: true,

  updateValidacionPago: false, //update cabecera y modulo
};

const TransaccionalContext = createContext({});

export function ContextProviderTransaccional({ children }) {
  const [informacionTransaccional, setInformacionTransaccional] =
    useState(valuesTransaccional);

  return (
    <TransaccionalContext.Provider
      value={{ informacionTransaccional, setInformacionTransaccional }}
    >
      {children}
    </TransaccionalContext.Provider>
  );
}

export default TransaccionalContext;
